import {
    Modal as ModalComponent,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
} from '@chakra-ui/react'

const Modal = ({ children, isOpen, onClose, headerTitle, size = 'lg' }) => {
    return (
        <ModalComponent size={size} isCentered isOpen={isOpen} onClose={onClose} motionPreset='scale' scrollBehavior={"inside"}>
            <ModalOverlay
                bg='rgba(0, 0, 0, 0.733)'
                backdropFilter='auto'
                backdropInvert='30%'
                backdropBlur='5px' onClick={onClose} />
            <ModalContent className="!m-auto !w-max min-w-[100vw] md:min-w-[680px] !max-w-[100%] bg-white dark:bg-navy-800">
                <ModalHeader className="text-black dark:text-white bg-lightPrimary dark:bg-navy-900">
                    {headerTitle}
                </ModalHeader>
                <ModalCloseButton color={'white'} bg={'red'} top={4} right={6} className="hover:contrast-[90%] active:contrast-[125%]" />
                <ModalBody>
                    {children}
                </ModalBody>
            </ModalContent>
        </ModalComponent>
    );
};

export default Modal;